var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React, { useState } from 'react';
import { COLORS, SIZES } from '@fupa/fupa-uikit';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { LinkOnComponent } from 'app/components/links/link';
import { useHistory, useLocation } from 'react-router';
import { useEffectAfterMount } from 'app/hooks/dataHooks';
import { reduxSelectDistrict } from 'app/hooks/reduxSelectDistrict';
import { NavBarIndex } from 'app/components/navBar/NavBarIndex';
import NavBarItemHome from 'app/components/navBar/NavBarItemHome';
import NavBarItemMatches from 'app/components/navBar/NavBarItemMatches';
import NavBarItemCompetitions from 'app/components/navBar/NavBarItemCompetitions';
import NavBarItemSearch from 'app/components/navBar/NavBarItemSearch';
import useDistrictUrls from 'app/hooks/useDistrictUrls';
const Container = styled.nav.withConfig({
  componentId: "sc-150le52-0"
})(["transform:translate3d(0,0,0);-webkit-transform:translate3d(0,0,0);position:fixed;z-index:", ";display:flex;justify-content:center;min-height:", ";overflow:hidden;bottom:0;width:100vw;background-color:", ";box-shadow:0 -1px 3px 0 ", ";padding:", " 0;padding-bottom:calc(", " + env(safe-area-inset-bottom));", ""], props => props.theme.zIndexNavigation, SIZES['64'], COLORS.lightestGrey, COLORS.grey, SIZES['10'], SIZES['10'], props => props.theme.desktopLayout(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    all: initial;\n    display: flex;\n    justify-content: center;\n  "]))));
const Wrapper = styled.div.withConfig({
  componentId: "sc-150le52-1"
})(["display:flex;flex:1;max-width:", "px;"], props => props.theme.desktopContentWidth);
const Line = styled.div.withConfig({
  componentId: "sc-150le52-2"
})(["display:none;", ""], props => props.theme.desktopLayout(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: block;\n    box-sizing: border-box;\n    height: 2.5rem;\n    border: 1px solid ", ";\n    margin-left: 0.625rem;\n  "])), COLORS.fupaPrimaryFocused));
const searchUrl = '/search';
const getActiveIdFromPathname = (pathname, currentValue) => {
  if (pathname.match("^(/region/[a-zA-Z0-9-]+|/my)/matches+.*$")) {
    return NavBarIndex.Matches;
  } else if (pathname.match("^/region/[a-zA-Z0-9-]+/competitions+.*$")) {
    return NavBarIndex.Competitions;
  } else if (pathname.match("^/(test_)?region/[a-zA-Z0-9-]+")) {
    return NavBarIndex.Home;
  } else if (pathname === searchUrl) {
    return NavBarIndex.Search;
  } else if (/\/(about|settings|devtools|following)/.test(pathname)) {
    return -1;
  }
  return currentValue;
};
export default function NavBar(_ref) {
  let {
    className,
    idSuffix
  } = _ref;
  const location = useLocation();
  const district = useSelector(reduxSelectDistrict);
  const [activeId, setActiveId] = useState(() => getActiveIdFromPathname(location.pathname, NavBarIndex.Home));
  const {
    districtMainUrl,
    districtMatchesUrl,
    districtCompetitionsUrl
  } = useDistrictUrls(district.slug);
  const isRegion = /^\/(test_)?region\//.test(location.pathname);
  // When fetching server-rendered pages like news from the s3 cache,
  // the links in the navbar are already set with a region (mostly the region of the author).
  // While hydrating the user could click on the navbar and navigate to a region he does not expect.
  // To prevent this, we use onClick handlers instead of links on urls other than /region/*
  const tabComponent = isRegion ? LinkOnComponent : 'div';
  const history = useHistory();
  const handleClick = (id, url) => {
    if (!isRegion) {
      setActiveId(id);
      history.push(url);
    }
  };
  useEffectAfterMount(() => {
    const newActiveId = getActiveIdFromPathname(location.pathname, activeId);
    setActiveId(newActiveId);
  }, [location.pathname]);
  return /*#__PURE__*/React.createElement(Container, {
    id: "fupa-nav-bar-".concat(idSuffix),
    className: className,
    "data-sentry-element": "Container",
    "data-sentry-component": "NavBar",
    "data-sentry-source-file": "NavBar.tsx"
  }, /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-source-file": "NavBar.tsx"
  }, /*#__PURE__*/React.createElement(NavBarItemHome, {
    isSelected: activeId === NavBarIndex.Home,
    link: districtMainUrl,
    onClick: () => handleClick(NavBarIndex.Home, districtMainUrl),
    componentType: tabComponent,
    "data-sentry-element": "NavBarItemHome",
    "data-sentry-source-file": "NavBar.tsx"
  }), /*#__PURE__*/React.createElement(NavBarItemMatches, {
    isSelected: activeId === NavBarIndex.Matches,
    link: districtMatchesUrl,
    onClick: () => handleClick(NavBarIndex.Matches, districtMatchesUrl),
    componentType: tabComponent,
    districtSlug: district.slug,
    "data-sentry-element": "NavBarItemMatches",
    "data-sentry-source-file": "NavBar.tsx"
  }), /*#__PURE__*/React.createElement(NavBarItemCompetitions, {
    isSelected: activeId === NavBarIndex.Competitions,
    link: districtCompetitionsUrl,
    onClick: () => handleClick(NavBarIndex.Competitions, districtCompetitionsUrl),
    componentType: tabComponent,
    "data-sentry-element": "NavBarItemCompetitions",
    "data-sentry-source-file": "NavBar.tsx"
  }), /*#__PURE__*/React.createElement(NavBarItemSearch, {
    isSelected: activeId === NavBarIndex.Search,
    link: searchUrl,
    onClick: () => handleClick(NavBarIndex.Search, searchUrl),
    componentType: tabComponent,
    "data-sentry-element": "NavBarItemSearch",
    "data-sentry-source-file": "NavBar.tsx"
  })), /*#__PURE__*/React.createElement(Line, {
    "data-sentry-element": "Line",
    "data-sentry-source-file": "NavBar.tsx"
  }));
}
export { NavBar };